"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
function default_1() {
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const customDeliveries = isPreview
        ? (0, react_redux_1.useSelector)((state) => state.customDeliveries)
        : (0, react_redux_1.useSelector)((state) => state.roomData.deliveries).filter((delivery) => delivery.delivery_type === 6);
    const perChunk = 3;
    const isScrollable = customDeliveries.length > perChunk;
    const chunkedDeliveries = (0, functions_1.chunkArray)(customDeliveries, perChunk);
    const { scrollDiv, setScrollDiv } = (0, functions_1.useHorizontalDragScroll)(isScrollable);
    const customDeliveryId = (0, react_redux_1.useSelector)((state) => state.customDeliveryId) || 0;
    (0, react_1.useEffect)(() => {
        if (!!customDeliveryId && !!scrollDiv) {
            const targetIndex = customDeliveries.findIndex((delivery) => delivery.id === customDeliveryId);
            scrollDiv.scrollTo(targetIndex < 3 ? 0 : 1000, 0);
        }
    }, [customDeliveryId, scrollDiv]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const setDeliveryId = (deliveryId) => {
        dispatch((0, roomViewStore_1.setCustomDeliveryId)(deliveryId));
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(RadioGroup_1.default, Object.assign({ ref: setScrollDiv, value: customDeliveryId, onChange: e => !isPreview && setDeliveryId(Number(e.target.value)), className: "horizontal_drag_scroll no_scroll_bar", sx: {
            flexFlow: 'row nowrap',
            columnGap: '8px',
            p: '0 16px',
            '.list_slide': {
                display: 'grid',
                alignContent: 'flex-start',
                flexShrink: 0,
                rowGap: '8px',
                height: 'auto',
                '.MuiFormControlLabel-root': {
                    display: 'flex',
                    height: '48px',
                    p: '0px 14px 0px 10px',
                    border: '1px solid var(--gray-10)',
                    borderRadius: '12px',
                    m: 0,
                    '&[aria-selected="true"]': {
                        border: '1px solid var(--gray-80)',
                    },
                },
                '.MuiFormControlLabel-label': {
                    display: 'flex',
                    flexGrow: '1',
                    columnGap: '10px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pl: '6px',
                },
            },
        } }, { children: chunkedDeliveries.map((chunk, chunkIdx) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "list_slide", css: { width: isScrollable ? '82%' : '100%' } }, { children: chunk.map((delivery, chunkedDeliveryIndex) => {
                const { id: deliveryId, name, delivery_price } = delivery;
                return ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { "aria-selected": customDeliveryId === deliveryId, value: deliveryId, control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: name })), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4 gray-80" }, { children: [(0, string_utils_1.money)(Number(delivery_price)), t('원')] }))] }) }, `custom_delivery_radio_${chunkIdx}_${deliveryId}_${chunkedDeliveryIndex}`));
            }) }), `chunked_deliveries_${chunkIdx}`))) })));
}
exports.default = default_1;
